import { Auth } from '@aws-amplify/auth';

type CookieStorageOptions = {
  domain: string;
  secure: boolean;
  path: string;
  expires: number;
  sameSite: 'strict' | 'lax' | 'none';
};

type OAuthConfig = {
  domain: string;
  scope: string[];
  redirectSignIn: string;
  redirectSignOut: string;
  responseType: 'code';
};

type AuthConfig = {
  region: string;
  userPoolId: string;
  userPoolWebClientId: string;
  mandatorySignIn: boolean;
  authenticationFlowType: 'USER_PASSWORD_AUTH';
  cookieStorage: CookieStorageOptions;
  oauth?: OAuthConfig;
  endpoint?: string;
};

const isDev = process.env.NODE_ENV === 'development';

const cookieStorage: CookieStorageOptions = {
  domain: isDev ? 'localhost' : 'listwithclever.com',
  secure: !isDev,
  path: '/',
  expires: 365, // expires in days
  sameSite: isDev ? 'lax' : 'none',
};

const authConfig: AuthConfig = {
  region: process.env.AWS_AMPLIFY_REGION || '',
  userPoolId: process.env.AWS_AMPLIFY_USER_POOL_ID || '',
  userPoolWebClientId: process.env.AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID || '',
  mandatorySignIn: true,
  authenticationFlowType: 'USER_PASSWORD_AUTH',
  cookieStorage,
  ...(process.env.AWS_AMPLIFY_COGNITO_ENDPOINT && {
    endpoint: process.env.AWS_AMPLIFY_COGNITO_ENDPOINT,
  }),
};

if (process.env.GATSBY_AWS_AMPLIFY_OAUTH_DOMAIN) {
  authConfig.oauth = {
    domain: process.env.GATSBY_AWS_AMPLIFY_OAUTH_DOMAIN,
    scope: ['openid', 'email', 'profile', 'aws.cognito.signin.user.admin'],
    redirectSignIn: process.env.GATSBY_AWS_AMPLIFY_REDIRECT_SIGN_IN || '',
    redirectSignOut: process.env.GATSBY_AWS_AMPLIFY_REDIRECT_SIGN_OUT || '',
    responseType: 'code',
  };
}

Auth.configure(authConfig);
